export const recaptchaInit = async(page) => {

    const action = (page || 'home') + '_page';

    const token = await grecaptcha.execute('6LcHvA8cAAAAAD28XU_57DgIgicHmHZ85gdEV3DE', {

        action: action

    })

    .then((token) => {

        if (token) {

            return token;
        }

        return false;

    });

    return token;
};